
import Vue from 'vue';
import ApiIntegrationCard from './ApiIntegrationCard.vue';

export default Vue.extend({
	name: 'ApiIntegrationsSection',
	props: {
		loadingToken: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		ApiIntegrationCard,
	},
});
